import { useToast } from '@app/core/notifications';
import { AuditLiveMention } from '@mi-front/core';
import { Modal } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { apiClient } from '../../../../../../api';
import { MatchesAddScreenPropsP } from '../matches-add/screen_p';
import { MentionManualForm } from './MentionManualForm';

import { FormattedMessage } from 'react-intl';
type Props = Pick<MatchesAddScreenPropsP, 'station' | 'datetime' | 'show' | 'onHide'> & {
  onSuccess?: (match: AuditLiveMention) => unknown;
};

export const MentionsAddPage = (p: Props) => {
  const { station, datetime, show, onHide, onSuccess } = p;
  const { $t } = useIntl();
  const { notifySuccess, notifyError } = useToast();

  return (
    <Modal
      size="md"
      show={show}
      onHide={onHide}
      showCloseButton={false}
      noBody
      title={
        <div style={{ display: 'flex' }}>
          <FormattedMessage
            id="audit.liveMentionsAdd.title"
            defaultMessage="Crear mención manual"
          />
        </div>
      }
    >
      <MentionManualForm
        station={station}
        datetime={datetime}
        submitFn={async (data) => {
          try {
            const match = await apiClient.audit.createManualLiveMention(station.id, data);

            notifySuccess(
              $t({
                id: 'audit.liveMentions.created',
                defaultMessage: 'Mención manual creada',
              }),
            );

            onHide();

            onSuccess && onSuccess(match);
          } catch (err: any) {
            notifyError(
              $t({
                id: 'audit.liveMentions.createError',
                defaultMessage: 'Mención no creada, intente de nuevo',
              }),
            );

            throw err;
          }
        }}
        cancel={onHide}
      />
    </Modal>
  );
};
